import { Component, Host, h, Prop, Element } from '@stencil/core';
import { addIntersectionObserver, checkLanguageCookie } from '../../utils/utils';

@Component({
  tag: 'banner-article',
  styleUrl: 'banner-article.css',
  shadow: false,
})
export class BannerArticle {
  /**
   * The title
   */
  @Prop() mainTitle: string;

  /**
   * Buttons Data
   */
  @Prop() buttonsData: string;

  /**
   * Tags Data
   */
  @Prop() tagsData: string;

  /**
   * Asset Type
   */
  @Prop() assetType: string;

  /**
   * Image alt
   */
  @Prop() imageAlt: string;

  /**
   * Image Url
   */
  @Prop() imageUrl: any;

  /**
   * Video
   */
  @Prop() videoUrl: string;

  /**
   * Author Name
   */
  @Prop() authorName: string;

  /**
   * Post Type
   */
  @Prop() postType: string;

  /**
   * Post Date
   */
  @Prop() postDate: string;

  /**
   * Background Color
   */
  @Prop() backgroundColor: string;

  /**
   * Text Color
   */
  @Prop() textColor: string;

  /**
   * Padding Top
   */
  @Prop() paddingTop: string;

  /**
   * Padding Bottom
   */
  @Prop() paddingBottom: string;

  /**
   * Custom Content Type
   */
  @Prop() customContentType: string;

  /**
   * Custom Class
   */
  @Prop() customClass: string;

  /**
   * Custom Post Date
   */
  @Prop() customPostDate: string;  

  /**
   * Background Image Url
   */
  @Prop() backgroundImage: string;

  // private getText(): string {
  //   return format(this.first, this.middle, this.last);
  // }
  @Element() el: HTMLElement;

  componentDidLoad() {
    addIntersectionObserver(
      this.el.querySelector('.banner-grid-article-container'),
      () => {
        this.el.querySelector('.banner-grid-article-container').classList.add('animate');
      },
      ['.overlay1', '.overlay2'],
    );
  }

  render() {
    const buttons = JSON.parse(this.buttonsData);
    const tags = JSON.parse(this.tagsData);
    const title = JSON.parse(this.mainTitle);

    // Get the language code from the cookie
    const langCode = checkLanguageCookie('wp-wpml_current_language');
    // Construct the href dynamically
    const href = langCode ? `/${langCode}/resource-center/` : '/resource-center/';
    // const showTags = [
    //   'California Prop 65',
    //   'Chemicals',
    //   'Construction',
    //   'Consumer Packaged Goods',
    //   'ECHA',
    //   'Energy & Utilities',
    //   'EPA',
    //   'EU PCN',
    //   'GHS',
    //   'Healthcare & Hospitals',
    //   'Manufacturing',
    //   'Oil & Gas',
    //   'PFAS',
    //   'Pharma',
    //   'Plastics',
    //   'Product Stewardship',
    //   'REACH',
    //   'Retail',
    //   'RoHS',
    //   'SCIP',
    //   'Supply Chain',
    //   'Sustainability',
    //   'Transportation',
    //   'TSCA',
    //   'UFLPA',
    //   'Workplace Safety',
    // ];

    const showTagsIds = [
      50, //CA Prop 65
      57, //ECHA
      59, //EPA
      61, //EU PCN
      198, //GHS
      66, //PFAS
      105, //Product Stewardship
      70, //REACH
      73, //RoHS
      74, //SCIP
      80, //UFLPA
      79, //TSCA
      126, //Sustainability
      26, //Chemicals
      27, //Construction
      28, //Consumer Packaged Goods
      127, //Energy & Utilities
      118, //Healthcare & Hospitals
      116, //Supply Chain Visibility
      31, //Manufacturing
      117, //Oil & Gas
      33, //Pharma
      34, //Plastics
      35, //Retail
      36, //Transportation
      92, //Supply Chain
      119, //Chemical &Workplace Safety
      186, //Article
      172, //Case Study
      187, //Guide
      189, //News and insights
      180, //on-demand webinar
      192, //Press Release
      176, //Whitepaper
    ];
    return (
      <Host>
        <div class={`container banner-grid-article-container ${this.paddingBottom} ${this.paddingTop}`}>
          <div class={`banner-grid-article`}>
            <div class={`overlay1`}></div>
            <div class={`banner-grid-article-col-1`} style={{ backgroundImage: `url(${this.backgroundImage})` }}>
              <div class={`banner-grid-article-content text-white ${this.textColor} bg-medium-blue ${this.backgroundColor}`}>
                {this.postType && (<h2 class={`banner-grid-article-content-type ${this.customClass}`}>{this.customContentType ? this.customContentType : this.postType}</h2>)}
                {this.mainTitle && <h1 class={`banner-grid-article-content-title`}>{title.replace(/â€˜/g, "'").replace(/â€™/g, "'").replace(/â€”/g, '-')}</h1>}{' '}
                <div class={`banner-grid-article-content-byline`}>
                  {this.postDate && <p class={`banner-grid-article-content-date`}>{this.customPostDate ? this.customPostDate : this.postDate} </p>}
                  {this.postDate && this.authorName && <p class={`banner-grid-article-content-separator`}>&nbsp;&nbsp;|&nbsp;&nbsp;</p>}
                  {this.authorName && <p class={`banner-grid-article-content-author`}> By {this.authorName}</p>}
                </div>
                {buttons && buttons.length > 0 && (
                  <div class="flex gap-12px mt-32px">
                    {buttons.map(button => (
                      <button-block buttonsData={button}></button-block>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div class={`banner-grid-article-col-2`}>
              <div class={`overlay2`}></div>
              <div class={`banner-grid-article-asset-wrapper`}>
                {this.assetType === 'image' && this.imageUrl && (
                  <image-block imageUrl={this.imageUrl} imageAlt={this.imageAlt} imageClass={`banner-grid-article-asset`}></image-block>
                )}
                {this.assetType === 'video' && this.videoUrl && <video-block videoUrl={this.videoUrl}></video-block>}
              </div>
              <div class={`banner-grid-article-tags-wrapper`}>
                {tags &&
                  tags.length > 0 &&
                  tags
                    .filter(({ tag_id }) => showTagsIds.includes(tag_id)) // Filter the tags array
                    .map(({ tag_id, tag_name }, index) => (
                      <a id={tag_id} key={index} href={`${href}?tag=${tag_id}`} class="banner-grid-article-tag">
                        <div innerHTML={`${tag_name}`}></div>
                      </a>
                    ))}
              </div>
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
